import { PayrollEmployeeCheckDto } from '@clh/api-client';

export function getZealCheckUrl(check: {
    status: PayrollEmployeeCheckDto['status'];
    zealEmployeeId: string | null;
    zealEmployeeCheckId: string;
}): string {
    if (check.status === 'PROCESSED' && check.zealEmployeeId) {
        return `https://payroll.humla.com/employees/${check.zealEmployeeId}?tab=employee_checks&cid=${check.zealEmployeeCheckId}`;
    }
    return `https://payroll.humla.com/pending-checks/check/${check.zealEmployeeCheckId}`;
}
